import { isCancel } from 'axios';

import { NotificationsStore } from '@shared/stores/NotificationsStore/NotificationsStore';
import { DEFAULT_QUERY_STALE_TIME } from '@shared/utilities/query/constants';
import { QueryApiNotifications } from '@shared/utilities/query/models';
import { QueryCache, QueryClient } from '@tanstack/react-query';

type NotificationMetaOptions = QueryApiNotifications<unknown, unknown, undefined> & { notifications: NotificationsStore };

export const createQueryClient = () =>
	new QueryClient({
		defaultOptions: { queries: { retry: 0, staleTime: DEFAULT_QUERY_STALE_TIME } },
		queryCache: new QueryCache({
			onError: (error, query) => {
				const options = query.meta as unknown as NotificationMetaOptions;
				const { notifications, notificationPrefix, notificationOptions, showErrorNotification = true } = options || {};

				if (isCancel(error) || !options || !showErrorNotification) {
					return;
				}

				const resolvedOptions =
					typeof notificationOptions === 'function' ? notificationOptions(undefined, error, undefined) : notificationOptions;

				notifications.addApiNotification(false, notificationPrefix, resolvedOptions);
			},
			onSuccess: (data, query) => {
				const options = query.meta as unknown as NotificationMetaOptions;
				const { notifications, notificationPrefix, notificationOptions, showSuccessNotification } = options || {};

				if (!options || !showSuccessNotification) {
					return;
				}

				const resolvedOptions =
					typeof notificationOptions === 'function' ? notificationOptions(data, undefined, undefined) : notificationOptions;

				notifications.addApiNotification(true, notificationPrefix, resolvedOptions);
			},
		}),
	});

export const queryClient = createQueryClient();
